import React, { FC, useContext } from 'react'
import { t } from '@lingui/macro'
import { Flex, Box, Text } from 'front-end/src/components'

import IconTrash from '../../../components/common/icon/IconTrash'
import IconButton from '../../../components/common/form/button/IconButton'
import { TableRow, TableCol } from '../../../components/common/table/Table'
import { Certification } from './NewCertificateItemModal'
import { TypeOfElement } from '../../../../../types/generic'
import { IconArrowUp } from '../../../components/common/icon/IconArrowUp'
import { IconArrowDown } from '../../../components/common/icon/IconArrowDown'
import {
  MainColumn,
  MiscColumn
} from '../../certification-page/CertificationItem'
import { ManageCertificationPageContext } from './ManageCertificationPage'
import { useRemoveCertificationItemMutation } from './ItemModal.codegen'
import {
  useMoveCertificationItemUpMutation,
  useMoveCertificationItemDownMutation
} from './ManageCertificationItem.codegen'
import { brandColors } from 'shared/basicPalette'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'

interface IProps {
  item: TypeOfElement<Certification['items']>
  first: boolean
  last: boolean
  locked: boolean
}

export const ManageCertificationItem: FC<IProps> = ({
  item,
  first,
  last,
  locked
}) => {
  const { certification, refetch } = useContext(ManageCertificationPageContext)
  const [removeItem] = useRemoveCertificationItemMutation()
  const [moveUp] = useMoveCertificationItemUpMutation()
  const [moveDown] = useMoveCertificationItemDownMutation()

  return (
    <TableRow>
      {/* @ts-expect-error  9/11/2020*/}
      <MainColumn item={item} />
      {/* @ts-expect-error  9/11/2020*/}
      <MiscColumn item={item} />
      {!locked && (
        <TableCol>
          <Text
            fontSize={fontSizes.xl}
            color={brandColors.grey.light}
            textAlign="right"
          >
            <IconButton
              icon={
                <Box
                  fontSize="18px"
                  color={brandColors.grey.mid}
                  lineHeight="24px"
                >
                  <IconTrash />
                </Box>
              }
              hint={t`Remove`}
              onClick={() => {
                removeItem({
                  variables: {
                    id: certification.id,
                    itemId: item.id
                  }
                })
              }}
            />
          </Text>
        </TableCol>
      )}
      {!locked && (
        <TableCol css={{ width: '16px' }}>
          <Flex
            h={'48px'}
            direction="column"
            justify="space-between"
            color={brandColors.grey[200]}
            textAlign="right"
          >
            <Box
              onClick={async () => {
                await moveUp({
                  variables: {
                    id: certification.id,
                    itemId: item.id
                  }
                })
                refetch()
              }}
              _hover={{
                color: brandColors.grey[500]
              }}
              cursor="pointer"
            >
              {!first && <IconArrowUp boxSize="16px" />}
            </Box>
            <Box
              onClick={async () => {
                await moveDown({
                  variables: {
                    id: certification.id,
                    itemId: item.id
                  }
                })
                refetch()
              }}
              _hover={{
                color: brandColors.grey[500]
              }}
              cursor="pointer"
            >
              {!last && <IconArrowDown boxSize="16px" />}
            </Box>
          </Flex>
        </TableCol>
      )}
    </TableRow>
  )
}
